import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import expertise from "../../../assets/expertise.jpeg";

const ExpertiseSection = ({ expertiseData, currentIndex }) => {
    const ref = useRef(null);

    // Detect Scroll Progress
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"], // Trigger animation within viewport range
    });

    // Scroll-based animations
    const opacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0, 1, 1, 0]); // Fade in and out
    const scale = useTransform(scrollYProgress, [0, 0.5, 1], [0.8, 1, 1]); // Scale effect

    return (
        <div ref={ref} className="relative overflow-hidden text-black py-20 ">
            {/* Animated Title */}
            <motion.h2
                style={{ opacity, scale }}
                className="text-3xl md:text-5xl lg:text-7xl font-bold text-center text-black"
            >
                Build a Better Future With <span className="text-green-400">Us</span>
            </motion.h2>

            {/* Content Section */}
            <div className="mt-10 flex flex-wrap justify-center items-center gap-6 overflow-hidden ">
                <motion.div
                    style={{ opacity, scale }}
                    className="relative w-full sm:w-[320px] md:w-[350px] lg:w-full flex-shrink-0 text-center"
                >
                    {/* Progress Bars */}
                    <div className="absolute top-3 left-4 right-4 flex space-x-2 z-10">
                        {expertiseData.map((_, index) => (
                            <div key={index} className="w-full h-1 bg-gray-600 rounded-full overflow-hidden">
                                <motion.div
                                    className="h-full bg-white"
                                    animate={{ width: index === currentIndex ? "100%" : "0%" }}
                                    initial={{ width: "0%" }}
                                    transition={{
                                        duration: index === currentIndex ? 10 : 0,
                                        ease: "linear"
                                    }}
                                />
                            </div>
                        ))}
                    </div>

                    {/* Background Image */}
                    <img
                        src={expertise}
                        alt="Expertise"
                        className="w-full rounded-2xl object-cover h-[300px]"
                    />
                    <div className="absolute inset-0 bg-black/50 backdrop-blur-lg rounded-2xl"></div>

                    {/* Changing Content */}
                    <motion.div
                        key={currentIndex}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.5 }}
                        className="absolute bottom-10 left-10 right-10 z-10 text-left"
                    >
                        <div className="text-white text-3xl">{expertiseData[currentIndex].icon}</div>
                        <h3 className="text-lg md:text-xl font-bold text-white mt-4">
                            {expertiseData[currentIndex].title}
                        </h3>
                        <p className="text-sm md:text-base text-white mt-2">
                            {expertiseData[currentIndex].description}
                        </p>
                    </motion.div>
                </motion.div>
            </div>
        </div>
    );
};

export default ExpertiseSection;
